<div class="quick-weeks">
  <span>Quick weekly alert filters:</span>
  <button
    mat-button
    type="button"
    (click)="selectWeek(0)"
    matTooltip="Previous complete Monday to Sunday"
  >
    Last complete week
  </button>
  <button
    mat-button
    type="button"
    (click)="selectWeek(1)"
    matTooltip="The complete week before last"
  >
    2 weeks ago
  </button>
  <button mat-button type="button" (click)="selectWeek(2)">3 weeks ago</button>
  <button mat-button type="button" (click)="selectWeek(3)">4 weeks ago</button>
</div>
<div
  class="filter-help"
  matTooltip="Use both dates together. Results include records from the start time through the end time. Leave dates blank to use the backend's default flagged findings."
>
  <span class="help-icon">?</span>
  <span>
    Filter by the transcript analysis timestamp using calendar date pickers.
  </span>
</div>
<div class="filters">
  <mat-form-field appearance="outline">
    <mat-label>Start date</mat-label>
    <input
      matInput
      [matDatepicker]="startPicker"
      [(ngModel)]="startDate"
      placeholder="Select start date"
    />
    <mat-datepicker-toggle
      matIconSuffix
      [for]="startPicker"
    ></mat-datepicker-toggle>
    <mat-datepicker #startPicker></mat-datepicker>
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>End date</mat-label>
    <input
      matInput
      [matDatepicker]="endPicker"
      [(ngModel)]="endDate"
      placeholder="Select end date"
    />
    <mat-datepicker-toggle
      matIconSuffix
      [for]="endPicker"
    ></mat-datepicker-toggle>
    <mat-datepicker #endPicker></mat-datepicker>
  </mat-form-field>
  <mat-form-field
    appearance="outline"
    matTooltip="Optional: match one exact DynamoDB transcript timestamp (sk). Do not combine this with a partial timestamp."
  >
    <mat-label>Exact timestamp / sk</mat-label>
    <input matInput [(ngModel)]="sk" placeholder="Optional ISO timestamp" />
    <mat-hint>Optional exact match</mat-hint>
  </mat-form-field>
  <mat-form-field
    appearance="outline"
    matTooltip="Maximum number of findings returned by the API."
  >
    <mat-label>Result limit</mat-label>
    <mat-select [(ngModel)]="limit">
      <mat-option [value]="10">10</mat-option>
      <mat-option [value]="25">25</mat-option>
      <mat-option [value]="50">50</mat-option>
      <mat-option [value]="100">100</mat-option>
    </mat-select>
  </mat-form-field>
  <button
    mat-flat-button
    color="primary"
    matTooltip="Query flagged PII, risky-advice, and smoke/fire findings using the selected filters."
    (click)="apply.emit()"
  >
    Apply filters
  </button>
  <button
    mat-stroked-button
    matTooltip="Remove the date, timestamp, and limit filters, then load the default flagged findings."
    (click)="onClear()"
  >
    Clear filters
  </button>
  <button
    mat-button
    matTooltip="Run the same query again with the current filters."
    (click)="refresh.emit()"
  >
    Refresh
  </button>
</div>
